 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLTITLE from '@/components/xhtml/title'
 import XHTMLFMIMAGE1 from '@/components/xhtml/fm-image1'
 import XHTMLCONTENTS from '@/components/xhtml/contents'
 import XHTMLFMIMAGE2 from '@/components/xhtml/fm-image2'
 import XHTMLMAKING_SUSTAINABLE from '@/components/xhtml/making_sustainable'
 import XHTMLPREPARING from '@/components/xhtml/preparing'
 import XHTMLTOOLS_MATERIALS from '@/components/xhtml/tools_materials'
 import XHTMLPART1 from '@/components/xhtml/part1'
 import XHTMLCHAPTER1 from '@/components/xhtml/chapter1'
 import XHTMLCHAPTER2 from '@/components/xhtml/chapter2'
 import XHTMLCHAPTER3 from '@/components/xhtml/chapter3'
 import XHTMLCHAPTER4 from '@/components/xhtml/chapter4'
 import XHTMLCHAPTER5 from '@/components/xhtml/chapter5'
 import XHTMLCHAPTER6 from '@/components/xhtml/chapter6'
 import XHTMLCHAPTER7 from '@/components/xhtml/chapter7'
 import XHTMLCHAPTER8 from '@/components/xhtml/chapter8'
 import XHTMLCHAPTER9 from '@/components/xhtml/chapter9'
 import XHTMLCHAPTER10 from '@/components/xhtml/chapter10'
 import XHTMLCHAPTER11 from '@/components/xhtml/chapter11'
 import XHTMLCHAPTER12 from '@/components/xhtml/chapter12'
 import XHTMLCHAPTER13 from '@/components/xhtml/chapter13'
 import XHTMLCHAPTER14 from '@/components/xhtml/chapter14'
 import XHTMLCHAPTER15 from '@/components/xhtml/chapter15'
 import XHTMLCHAPTER16 from '@/components/xhtml/chapter16'
 import XHTMLCHAPTER17 from '@/components/xhtml/chapter17'
 import XHTMLCHAPTER18 from '@/components/xhtml/chapter18'
 import XHTMLCHAPTER19 from '@/components/xhtml/chapter19'
 import XHTMLCHAPTER20 from '@/components/xhtml/chapter20'
 import XHTMLTECHNIQUES from '@/components/xhtml/techniques'
 import XHTMLTEMPLATES from '@/components/xhtml/templates'
 import XHTMLSUPPLIERS from '@/components/xhtml/suppliers'
 import XHTMLINSPIRATION from '@/components/xhtml/inspiration'
 import XHTMLABOUTTHEAUTHOR from '@/components/xhtml/abouttheauthor'
 import XHTMLTHANKS from '@/components/xhtml/thanks'
 import XHTMLBMIMAGE from '@/components/xhtml/bm-image'
 import XHTMLCOPYRIGHT from '@/components/xhtml/copyright'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/contents",
 			"name" : "xhtml/contents",
 			"component" : XHTMLCONTENTS
 		},
 		{
 			"path" : "/xhtml/fm-image2",
 			"name" : "xhtml/fm-image2",
 			"component" : XHTMLFMIMAGE2
 		},
 		{
 			"path" : "/xhtml/making_sustainable",
 			"name" : "xhtml/making_sustainable",
 			"component" : XHTMLMAKING_SUSTAINABLE
 		},
 		{
 			"path" : "/xhtml/preparing",
 			"name" : "xhtml/preparing",
 			"component" : XHTMLPREPARING
 		},
 		{
 			"path" : "/xhtml/tools_materials",
 			"name" : "xhtml/tools_materials",
 			"component" : XHTMLTOOLS_MATERIALS
 		},
 		{
 			"path" : "/xhtml/part1",
 			"name" : "xhtml/part1",
 			"component" : XHTMLPART1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js